import { ProductNewModel } from "../../models/products/product-new-model";
import React, { useEffect, useRef, useState } from "react";
import ProductService from "../../services/products/products.service";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Helpers from "../../utils/helpers";
import { useTranslation } from "react-i18next";
import { InvoiceProduct } from "../../models/invoice/invoice-product-insert-model";
import { Toast, ToastMessage } from "primereact/toast";
import ProductInvoice from "../../services/invoices/gen_inv.service";
import AppLoading from '../app-loading/app-loading';
import { InputText } from "primereact/inputtext";
import { OrderDetail } from "../../models/orders/order-list-model";

export const AddProduct = ({ orderedItems, updateItems }: any) => {
  debugger;
  const { t } = useTranslation();
  const [products, setProducts] = useState<ProductNewModel[]>([]);
  const [quantity, setQuantity] = useState<any>();
  const toast = useRef<Toast>(null);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState<any>("");

  const showMessage = (
    label: string,
    message: string,
    severity: ToastMessage["severity"]
  ) => {
    toast.current?.show({
      severity: severity,
      summary: label,
      detail: message,
      life: 3000,
    });
  };

  const imageBodyTemplate = (item: any) => {
    const imageUrl = (item.productImageList?.mediaUrl || process.env.PUBLIC_URL + "/assests/images/Desiri-Groundnut-Oils.png");
    return (
      <img
        src={imageUrl}
        alt={item.name}
        onError={(e) => {
          (e.target as HTMLImageElement).src = "/assests/images/Desiri-Groundnut-Oils.png";
        }}
        style={{ objectFit: 'contain', borderRadius: '4px', width: '50px', height: '50px', display: 'block' }}
      />
    );
  };

  const addProductBtn = (product: any) => {
    return (
      <Button label="Add" onClick={(e) => handelAdd(product.id)}></Button>
    )
  }

  const unitPriceBodyTemplate = (product: any) => {
    return Helpers.formatAmountInINR(product.unitPrice);
  };

  const quantityTemplate = (product: any) => {
    return (
      <>
        <div className="flex product-item product-wrapper">
          <div className="product-list-quantity">
            <InputNumber
              inputId={String(product.orderID)}
              style={{ width: 120 }}
              value={product.minOrderQty}
              showButtons
              buttonLayout="horizontal"
              step={product.orderMultiples}
              decrementButtonClassName="p-button-danger"
              className="quantity-border"
              incrementButtonClassName="p-button-success"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
              min={product.minOrderQty}
              onValueChange={(e) => setQuantity(e.value)}
            />
          </div>
        </div>
      </>
    );
  };

  useEffect(() => {
    ProductService.getAllProducts().then((response) => {
      setProducts(response);
      setLoading(false);
    }).catch((error) => {
      console.error("Error fetching products:", error);
      setLoading(false);
    });
  }, []);

  async function handelAdd(id: number) {
    setLoading(true);
    const productItem = products.filter((x: any) => x.id === id)[0];
    const qty = quantity === undefined ? productItem.minOrderQty : quantity;
    const taxAmount = (productItem.unitPrice * qty) * (productItem.tax / 100);
    const taxableAmount = productItem.unitPrice * qty;

    const updatedInvoiceProduct: InvoiceProduct = {
      OrderID: orderedItems.orderID,
      ProductID: productItem.id,
      Quantity: qty,
      OrderStatusID: orderedItems.orderStatusID,
      UnitPrice: productItem.unitPrice,
      PendingQuantity: qty,
      TaxableAmount: taxableAmount,
      TaxAmount: taxAmount,
      DiscountAmount: orderedItems.discountAmount,
      TrackingID: '1',
      CourierDocketNbr: '',
      GrossAmount: taxableAmount + taxAmount,
      ModifiedBy: orderedItems.userID,
      ModifiedDate: orderedItems.modifiedDate,
      OrderGrossAmount: orderedItems.grossAmount + taxableAmount + taxAmount,
      OrderTaxableAmount: orderedItems.taxableAmount + taxableAmount,
      OrderTaxAmount: orderedItems.taxAmount + taxAmount
    };
    let response = await ProductInvoice.InsertProductToInvoice(updatedInvoiceProduct);

    setLoading(false);
    if (response.isSuccess) {
      showMessage(
        "Add Products",
        "Product Added successfully",
        "success"
      );
      const updatedOrderInvoiceDetails: OrderDetail = {
        orderDetailID: response.id,
        orderId: orderedItems.orderID,
        productID: productItem.id,
        productName: productItem.name,
        categoryName: productItem.categoryName,
        subCategoryName: productItem.subCategoryName,
        hsN_Code: '',
        orderStatusName: orderedItems.orderStatusName,
        measurementTypeName: '',
        unitPrice: productItem.unitPrice,
        minOrderQty: productItem.minOrderQty,
        orderMultiples: productItem.orderMultiples,
        quantity: qty,
        pendingQuantity: qty,
        taxableAmount: taxableAmount,
        gst: productItem.tax,
        taxAmount: taxAmount,
        grossAmount: taxableAmount + taxAmount,
        url: (Array.isArray(productItem.productImageList) ? (productItem.productImageList.find((img: any) => img.isDefault || img.IsDefault) || productItem.productImageList[0])?.mediaUrl : productItem.productImageList.mediaUrl),
        trackingID: '1',
        discountAmount: orderedItems.discountAmount
      };

      // UpdateItems with the updated product list
      orderedItems.orderDetail = [...orderedItems.orderDetail, updatedOrderInvoiceDetails];
      orderedItems.grossAmount = orderedItems.grossAmount + (taxableAmount + taxAmount);
      orderedItems.taxAmount = orderedItems.taxAmount + taxAmount;
      orderedItems.taxableAmount = orderedItems.taxableAmount + taxableAmount;
      updateItems(orderedItems);
    } else {
      showMessage(
        "Add Products",
        response.message,
        "info"
      );
    }
  }

  const filteredData = products.filter((item) =>
    (typeof item.name === 'string' && item.name.toLowerCase().includes(searchText.toLowerCase()))
  );

  return (

    <div className="col-12">
      <Toast ref={toast} position="top-right" />
      <div className="col-12">
        <div className="flex align-items-center flex-wrap gap-2">
          <div className=" font-bold text-white border-round  p-input-icon-left" style={{ float: "right" }}>
            <i className="fa-solid fa-search"></i>
            <InputText
              id="search"
              name="search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder={t("common_search_placeholder")}
            />
          </div>
        </div>
      </div>
      <DataTable value={filteredData} tableStyle={{ minWidth: '50rem' }}
        globalFilterFields={['name']}>
        <Column header="Image" style={{ width: "10%", marginLeft: "8rem" }} body={imageBodyTemplate}></Column>
        <Column
          field="name"
          style={{ width: "50%" }}
          header={t("invoices_product_name")}
        ></Column>
        <Column
          field="unitPrice"
          header={t("invoices_product_price")}
          body={unitPriceBodyTemplate}
        ></Column>
        <Column
          field="quantity"
          header={t("invoices_product_quantity")}
          body={quantityTemplate}
        ></Column>
        <Column field="id" header="Action" body={addProductBtn}></Column>
      </DataTable>
      {loading && <AppLoading />}
    </div>
  )
}